import { render, staticRenderFns } from "./treatment-step-three.html?vue&type=template&id=85c7adf6&scoped=true&"
import script from "./treatment-step-three.js?vue&type=script&lang=js&"
export * from "./treatment-step-three.js?vue&type=script&lang=js&"
import style0 from "./treatment-step-three.scss?vue&type=style&index=0&id=85c7adf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c7adf6",
  null
  
)

export default component.exports